import axios from 'axios';
import Page from '../../lib/page';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

function updateUserSelection() {
  return (dispatch, getState) => {
    if (Page.isLoggedIn()) {
      const { topicName } = getState().selectResult.topicTreeSelectResult;
      const kanaCode = getState().emailForm.kanaCode;
      return axios.post('/smarthelp/update-user-selection', {
        _csrf: Page.getCSRFtoken(),
        topicId: kanaCode,
        topicName,
      });
    }
    return undefined;
  };
}

module.exports = {
  updateUserSelection,
};



// WEBPACK FOOTER //
// ./contactUs/actions/action-update-user-selection.js